

exports.__esModule = true;
exports.$GenericMessageRoute = undefined;

require('./directive');

var _squid = require('squid');

var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {

    path: 'genericMessage',

    directive: 'xo-generic-message-page',

    query: ['code'],

    // need to find these values
    trackingData: {},

    auth: false,

    children: []
});

angular.value("$GenericMessageRoute", $GenericMessageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/route.js
// module id = ./pages/xo-generic-message/route.js
// module chunks = 0